import configure from '../util/configure';
import formatNumber from './format-number-with-string';
import { deconstructNumberFormat } from './deconstruct-number-format';
import { INumberLocalizer } from '../util/localizers';

const defaults = {
  decimal: '.',
  grouping: ','
};

export function simpleNumberLocalizer(options?: any): INumberLocalizer {
  const { decimal, grouping } = Object.assign({}, defaults, options);

  return {
    formats: {
      default: `-#${grouping}##0${decimal}`
    },

    // TODO major bump consistent ordering
    parse(num: string, _culture: string | undefined, format?: string) {
      let value: number;

      if (format) {
        // TODO: handle undefined
        const data = deconstructNumberFormat(format);
        const negative = (data.negativeLeftSymbol && num.indexOf(data.negativeLeftSymbol) !== -1)
                    || (data.negativeRightSymbol && num.indexOf(data.negativeRightSymbol) !== -1);

        num = num
          .replace(data.negativeLeftSymbol, '')
          .replace(data.negativeRightSymbol, '')
          .replace(data.prefix, '')
          .replace(data.suffix, '');

        const halves = num.split(data.decimalChar);

        if (data.integerSeparator) {
          halves[0] = halves[0].replace(new RegExp('\\' + data.integerSeparator, 'g'), '');
        }

        if (data.decimalsSeparator) {
          halves[1] = halves[1].replace(new RegExp('\\' + data.decimalsSeparator, 'g'), '');
        }

        if (halves[1] === '') {
          halves.pop();
        }

        num = halves.join('.');
        value = +num;

        if (negative) {
          value = -1 * value;
        }
      }
      else {
        value = parseFloat(num);
      }

      return isNaN(value) ? null : value;
    },

    format(value, format) {
      return formatNumber(value, format);
    },

    // TODO handle undefined
    decimalChar(format) {
      return format && deconstructNumberFormat(format)?.decimalsSeparator || '.';
    },

    precision(format: string) {
      // TODO handle undefined
      const data = deconstructNumberFormat(format);
      return data?.maxRight !== -1 ? data.maxRight : null;
    }
  };
}

export default function(options?: any) {
  const localizer = simpleNumberLocalizer(options);
  configure.setNumberLocalizer(localizer as any);
  return localizer;
}
